// Event scoping for the screens that build their own SQL conditions and send them to
// /comman/batch-list.
//
// Date + session + menu item is NOT a unique slot. Disabling an event and running a replacement
// over the same dates leaves both events' rows sitting on the same day, so a query keyed on the
// date alone reads whichever it happens to reach first -- on Recipe Planning that meant a new
// event's first open finding the OLD event's saved plan and never building from Recipe Master.
//
// This is the frontend half of backend/utils/event.js eventScopeOrNullClause, and matches it
// exactly, NULL branch included: rows written before event_id existed carry NULL, and dropping
// them would orphan every plan saved before the backfill rather than scope it.
//
// No event on the meal row -- an ordinary day outside any event -- means nothing to scope by, and
// the condition is left as it was.
export const eventScopeOrNull = (eventId) => {
  if (eventId === null || eventId === undefined || eventId === '') return '';
  return ` AND (event_id = '${eventId}' OR event_id IS NULL)`;
};
